var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"ma-0",style:(`
      position: absolute;
      background-image: radial-gradient(rgba(179, 130, 200, 0.1), rgba(142, 68, 173, 0.23), rgba(0, 0, 0, 0.82)), url(${_vm.spaceBackground});
      background-size: cover;
      height: 100%;
      overflow: hidden;
    `),attrs:{"fluid":""}},[(_vm.isElectron)?_c('div',{staticClass:"d-flex"},[_c('app-bar')],1):_vm._e(),_c('v-main',[_c('router-view')],1),_vm._l((30),function(item,index){return _c('div',{key:index,staticClass:"circle-container"},[_c('div',{staticClass:"circle"})])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }